// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => ("static/css/" + chunkId + "." + {"8457":"7b3550f0","9925":"d8b99615"}[chunkId] + ".chunk.css");